module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path class="st0" d="M14.8 14.8l19 19m-19 0l19-19"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-icon.svg
// module id = 458
// module chunks = 1